module.exports = __webpack_public_path__ + "img/dbsLogoWhite.9650c291.svg";